// extracted by mini-css-extract-plugin
export default {"zoomModal":"X1-z","image":"Y1-z","button":"Z1-z","isOverlayShown":"_1-z"};